
(() => {
  const normalize = (value) =>
    String(value || '')
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-|-$/g, '');

  function applyMaterialFilter(root = document) {
    root.querySelectorAll('product-info').forEach((info) => {
      const picker = info.querySelector('variant-selects');
      const gallery = info.querySelector('media-gallery');

      if (!picker || !gallery) return;

      const materialInputs = [
        ...picker.querySelectorAll(
          'input[data-option-name], option[data-option-name]'
        )
      ].filter(
        (el) =>
          normalize(el.dataset.optionName) === 'jewelry-material' ||
          normalize(el.dataset.optionName) === 'jewellery-material'
      );

      if (!materialInputs.length) return;

      const selected = materialInputs.find((el) =>
        el.matches('input:checked, option:checked')
      );

      if (!selected) return;

      const selectedMaterial = normalize(selected.value);
      if (!selectedMaterial) return;

      const slides = [
        ...gallery.querySelectorAll(
          '.product__media-list > li[data-media-id]'
        )
      ];

      const thumbnails = [
        ...gallery.querySelectorAll(
          '.thumbnail-list > li[data-target]'
        )
      ];

      const labelled = slides.filter((li) => {
        const img = li.querySelector('img[alt]');
        return (
          img &&
          ['white-gold', 'yellow-gold', 'rose-gold'].includes(
            normalize(img.getAttribute('alt'))
          )
        );
      });

      if (!labelled.length) return;

      const allowed = new Set();

      slides.forEach((li) => {
        const image = li.querySelector('img[alt]');
        const alt = image
          ? normalize(image.getAttribute('alt'))
          : '';

        const isTagged = [
          'white-gold',
          'yellow-gold',
          'rose-gold'
        ].includes(alt);

        const visible =
          !isTagged || alt === selectedMaterial;

        li.hidden = !visible;

        li.classList.toggle(
          'amara-material-hidden',
          !visible
        );

        if (visible) {
          allowed.add(li.dataset.mediaId);
        }
      });

      thumbnails.forEach((li) => {
        const visible = allowed.has(li.dataset.target);

        li.hidden = !visible;

        li.classList.toggle(
          'amara-material-hidden',
          !visible
        );
      });

      const active = slides.find((li) =>
        li.classList.contains('is-active')
      );

      if (!active || active.hidden) {
        const first = slides.find((li) => !li.hidden);

        if (first) {
          gallery.setActiveMedia?.(
            first.dataset.mediaId,
            false
          );
        }
      }
    });
  }

  let pending = false;

  function schedule() {
    if (pending) return;

    pending = true;

    requestAnimationFrame(() => {
      pending = false;
      applyMaterialFilter();
    });
  }

  document.addEventListener(
    'DOMContentLoaded',
    schedule
  );

  document.addEventListener('change', (event) => {
    if (event.target.closest('variant-selects')) {
      schedule();
    }
  });

  document.addEventListener(
    'shopify:section:load',
    schedule
  );

  if (
    typeof subscribe === 'function' &&
    typeof PUB_SUB_EVENTS !== 'undefined'
  ) {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }

  if (document.readyState !== 'loading') {
    schedule();
  }
})();
